//-------------------------------------------------------------------------------------------------- Imports
import { Typography, Divider, Card } from "antd";
import { StyleSheet } from "../StyleSheet";
import { images } from "../routes/ImageRoutes";
import { PaymentData } from "./AlertModal";
const { Text } = Typography;

type Props = {
    paymentData: PaymentData;
}

//-------------------------------------------------------------------------------------------------- Component
const ReceiptPayment = (props: Props) => {
    const { paymentData } = props;


    return (
        <div style={styles.mainContainer}>
            <Card style={styles.cardStyle} styles={{ body: styles.bodyContainer }}>
                <div style={styles.divRoot}>
                    <img
                        src={images.megaLogoMR}
                        alt="mega-logo"
                        style={styles.imageLogo}
                    />
                </div>
                <h3 style={styles.titlePayment}>
                    TOTAL PAGADO: ${paymentData.amount}
                </h3>
                <Text style={styles.titleDataPayment}>
                    {"CONCEPTO: "}
                    <Text style={styles.descriptionDataPayment}>
                        {paymentData.concept}
                    </Text>
                </Text>
                <Text style={styles.titleDataPayment}>
                    {"FECHA: "}
                    <Text style={styles.descriptionDataPayment}>
                        {paymentData.date}
                    </Text>
                </Text>
                <Text style={styles.titleDataPayment}>
                    {"HORA: "}
                    <Text style={styles.descriptionDataPayment}>
                        {paymentData.time}
                    </Text>
                </Text>
                <Divider style={styles.lineDivider} />
                <Text style={styles.descriptionDataPayment}>
                    {"CON CARGO A:"}
                </Text>
                <Text style={styles.titleDataPayment}>
                    {paymentData.name}
                </Text>
                <Text style={styles.titleDataPayment}>
                    {"CONTRATO: "}
                    <Text style={styles.descriptionDataPayment}>
                        {paymentData.client}
                    </Text>
                </Text>
                <Text style={{ ...styles.titleDataPayment, marginTop: 30 }}>
                    {"MEDIO DE PAGO: "}
                </Text>
                <Text style={styles.descriptionDataPayment}>
                    {paymentData.idTransaction ? "PAYPAL" : "TARJETA DÉBITO/CRÉDITO"}
                </Text>
                <Text style={{ ...styles.titleDataPayment, marginTop: 30 }}>
                    {paymentData.idTransaction ? "ID DE TRANSACCIÓN:" : "TARJETA:"}
                </Text>
                <Text style={styles.descriptionDataPayment}>
                    {paymentData.idTransaction ? paymentData?.idTransaction : paymentData?.card}
                </Text>
                <Divider style={styles.lineDivider} />
                <Text style={styles.timePayment}>
                    Su pago se verá reflejado en un
                </Text>
                <Text style={styles.timePayment}>
                    máximo de 24 horas
                </Text>
            </Card>
        </div >
    )
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#dedede",
        padding: 20
    },
    cardContainer: {
        width: 400,
        borderRadius: "15px",
    },
    headerContainer: {
        display: "flex",
        width: "100%",
        height: 150,
        borderRadius: "15px 15px 0px 0px",
        alignItems: "center",
        justifyContent: "center",
    },
    infoBGColor: {
        backgroundColor: "#e8b031",
    },
    successBGColor: {
        backgroundColor: "#0055c2",
    },
    errorBGColor: {
        backgroundColor: "#e00614",
    },
    iconStyle: {
        fontSize: 80,
        color: "#ffffff",
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "40px 20px 40px 20px",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
    },
    buttonsContainer: {
        display: "flex",
        width: 450,
        padding: "40px 0px 40px 0px",
        alignItems: "center",
        justifyContent: "center",
    },
    buttonStyle: {
        height: 40,
        fontSize: 18,
        fontWeight: 600,
        padding: "0px 40px 0px 40px",
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    infoColor: {
        margin: 0,
        marginBottom: 20,
        color: "#e8b031",
    },
    successColor: {
        margin: 0,
        marginBottom: 20,
        color: "#0055c2",
    },
    errorColor: {
        margin: 0,
        marginBottom: 20,
        color: "#e00614",
    },
    imageLogo: {
        maxHeight: 40,
        maxWidth: "100%",
        marginTop: 40,
        marginBottom: 15
    },
    divRoot: {
        maxWidth: "100%",
        maxheight: 30
    },
    cardStyle: {
        width: 400,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
    },
    cardBody: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        width: "100%"
    },
    megaTitle: {
        color: "#000000",
        fontSize: "1.2em",
        margin: "5px 0px",
        fontWeight: 600,
    },
    megaAdress: {
        color: "#000000",
        fontSize: "0.9em",
        fontWeight: 500,
    },
    lineDivider: {
        backgroundColor: '#b2b2b2',
        padding: 0.5,
        minWidth: "60%",
        width: "60%"
    },
    titlePayment: {
        color: "#000000",
        fontSize: "1.1em",
        margin: "20px 0px",
        fontWeight: 800,
    },
    titleDataPayment: {
        color: "#000000",
        fontSize: "1em",
        fontWeight: 800,
        lineHeight: 2
    },
    descriptionDataPayment: {
        color: "#000000",
        fontSize: "1em",
        fontWeight: 500,
    },
    timePayment: {
        color: "#000000",
        fontSize: "0.9em",
        fontWeight: 500,
        lineHeight: 1.3
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default ReceiptPayment;
